import { createIcon } from '@chakra-ui/react'

export const FileFolder = createIcon({
  displayName: 'FileFolder',
  viewBox: '0 0 32 26',
  d: 'M0.799805 3.39995C0.799805 1.63264 2.23249 0.199951 3.9998 0.199951H12.7998L15.9998 3.39995H27.9998C29.7671 3.39995 31.1998 4.83264 31.1998 6.59995V22.6C31.1998 24.3673 29.7671 25.8 27.9998 25.8H3.99981C2.23249 25.8 0.799805 24.3673 0.799805 22.6V3.39995Z',
})
